import { useLocalSearchParams } from 'expo-router'
import { UserSection } from '../../../../app/components/Admin/User/UserSection'

export default function UserId() {
  const params = useLocalSearchParams<{ userId: string }>()
  const userId = params.userId

  return <UserSection id={userId} />
}
